import { queryOptions, useQuery } from '@tanstack/react-query';

import type { BackendTypes } from '@tf/api';
import { BackendClient } from '@tf/api';

function getLastSegment(path: string) {
	const segments = path.split('/');
	return segments[segments.length - 1];
}

export const getObjectUriByNodeId = async (nodeId: BackendTypes.GraphId): Promise<string> => {
	const res = await BackendClient.getInstance().legacyObjectUriByNodeId(nodeId);
	return res.json();
};

export const getNodeIdByObjectUri = async (objectId: string): Promise<BackendTypes.GraphId> => {
	const res = await BackendClient.getInstance().legacyNodeIdByObjectUri(getLastSegment(objectId));
	return res.json();
};

const nodeIdQueryOptions = (objectId: string) => {
	return queryOptions({
		queryKey: ['nodeId', objectId],
		queryFn: async () => getNodeIdByObjectUri(objectId),
	});
};

export const useNodeIdByObjectUri = (objectId: string) => {
	return useQuery(nodeIdQueryOptions(objectId));
};

const objectUriQueryOptions = (nodeId: BackendTypes.GraphId) => {
	return queryOptions({
		queryKey: ['objectUri', nodeId],
		queryFn: async () => getObjectUriByNodeId(nodeId),
	});
};

export const useObjectUriByNodeId = (nodeId: BackendTypes.GraphId) => {
	return useQuery(objectUriQueryOptions(nodeId));
};
